import { render } from "./CadastroCliente.vue?vue&type=template&id=428dae19&scoped=true"
import script from "./CadastroCliente.vue?vue&type=script&lang=js"
export * from "./CadastroCliente.vue?vue&type=script&lang=js"

import "./CadastroCliente.vue?vue&type=style&index=0&id=428dae19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428dae19"]])

export default __exports__